import { Card } from "@/components/ui/Card";
import useDocumentTitle from "@/hooks/UseDocumentTitle";
import TasksManagementTable from "./component/table";

export default function TaskManagement() {
  useDocumentTitle("Tasks");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <TasksManagementTable/>
      </Card>
    </div>
  );
}
